<div
	class="page-header page-header-dark bg-gradient-primary-to-secondary mt-5"
	[ngClass]="{
		'pb-10': !simplified,
		'page-header-dark bg-gradient-primary-to-secondary': !light,
		'page-header-light bg-white shadow': light
	}">
	<div class="container-xl px-4">
		<div class="page-header-content pt-4">
			@if (loading) {
				<div class="row gx-4 align-items-center">
					<div class="col placeholder-glow">
						<span class="placeholder w-75"></span>
						<span class="placeholder w-50"></span>
					</div>
				</div>
			} @else {
				<div class="row gx-4 align-items-center justify-content-between">
					<div class="col-md mt-4">
						<h1 class="page-header-title">
							<div class="page-header-icon">
								@if (awesome && icon) {
									<fa-icon [icon]="iconProp"></fa-icon>
								} @else if (icon) {
									<i-feather [name]="icon"></i-feather>
								}
							</div>
							<span>{{ title }}</span>
						</h1>
						<div class="page-header-subtitle">{{ description }}</div>
						@if (breadcrumbs) {
							<sb-breadcrumbs></sb-breadcrumbs>
						}
					</div>
				</div>
				@if (showSearch) {
					<div class="page-header-search mt-4">
						<div class="input-group input-group-joined">
							<input class="form-control" type="text" placeholder="Search..." aria-label="Search" autofocus />
							<div class="input-group-text">
								<i-feather name="search"></i-feather>
							</div>
						</div>
					</div>
				}
			}
		</div>
	</div>
</div>
